const Header = ({ data }) => (
  <header id="top" className="relative tc josefin-sans white">
    <TopRow data={data} />
    {/* See: https://github.com/yahoo/react-stickynode */}
    <Sticky innerZ={100} activeClass="active">
      <NavBar data={data} />
    </Sticky>
  </header>
)

export default Header

/*
 *
 * Imports
 *
 */

import React, { Fragment } from 'react'
import shortid from 'shortid'
import Sticky from 'react-stickynode'

import HyperLink from '../components/base/HyperLink'
import ScrollTo from '../components/ScrollTo'

/*
 *
 * Top Row
 *
 */

import FaFacebook from 'react-icons/lib/fa/facebook'
import FaTwitter from 'react-icons/lib/fa/twitter'
import FaInstagram from 'react-icons/lib/fa/instagram'
import Headroom from 'react-headroom'

const TopRow = ({ data }) => (
  <Headroom disableInlineStyles>
    <div className="flex justify-between items-center pa3 w-100">
      <div className="flex-none sm:flex w-third tl ttu">
        <span className="v-mid fs-normal">{data.dates}</span>
        <span className="dn sm:dib">&nbsp;Premiere</span>
      </div>

      <nav aria-label="Social media links" className="w-third">
        <ul className="flex justify-center">
          {data.socials.map(social => {
            let Icon
            social.site === `Facebook` && (Icon = FaFacebook)
            social.site === `Twitter` && (Icon = FaTwitter)
            social.site === `Instagram` && (Icon = FaInstagram)

            return (
              <li key={shortid.generate()} className="ph1 sm:ph2">
                <HyperLink href={social.link}>
                  <span className="sr-only">Follow us on {social.site}</span>
                  <Icon
                    aria-hidden="true"
                    className="f4 animate hover:dark-pink"
                  />
                </HyperLink>
              </li>
            )
          })}
        </ul>
        <h2 className="dn lg:db pt2 f7 fw4 ttu">{data.socialHeading}</h2>
      </nav>

      <HyperLink href={data.venue.link} className="dn lg:dib pl3 w-third tr ttu i">
        <span className="pink">
          {data.venue.pinkText}
          &nbsp;
        </span>
        {data.venue.whiteText}
      </HyperLink>

      <div className="lg:dn w-third tr">
        <MenuButton nav={data.nav} />
      </div>
    </div>
  </Headroom>
)

/*
 *
 * Menu (button that triggers menu overlay)
 *
 */

import Modal from 'react-modal'
import noScroll from 'no-scroll'
import FaBars from 'react-icons/lib/fa/bars'

import MenuOverlay from '../components/MenuOverlay'

// Repo: https://github.com/reactjs/react-modal
// Docs: http://reactcommunity.org/react-modal/

class MenuButton extends React.Component {
  state = { modalIsOpen: false }

  componentDidMount = () => {
    // Bind modal to appElement (http://reactcommunity.org/react-modal/accessibility/)
    Modal.setAppElement(`#___gatsby`)
  }

  openModal = () => {
    this.setState({ modalIsOpen: true })
    noScroll.on()
  }

  closeModal = () => {
    noScroll.off()
    this.setState({ modalIsOpen: false })
  }

  render() {
    const { nav } = this.props

    return (
      <Fragment>
        <button type="button" onClick={this.openModal}>
          <span className="sr-only">Open menu</span>
          <FaBars className="f3 white animate hover:dark-pink" />
        </button>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          closeTimeoutMS={400} // match exit animation timing
          overlayClassName="menu-modal-overlay flex justify-center items-center fixed fill z-max bg-purple"
          className="menu-modal-content absolute fill"
        >
          <MenuOverlay nav={nav} closeModal={this.closeModal} />
        </Modal>
      </Fragment>
    )
  }
}

/*
 *
 * Nav Bar
 *
 */

import BuyTickets from '../components/BuyTickets'

const NavBar = ({ data }) => (
  <div className="sticky-header dn lg:db pv3 ttu i">
    <a href="#main-content" className="sr-only">
      Skip Navigation
    </a>
    <nav aria-label="Main navigation">
      <ul className="flex justify-center items-center pt1">
        {data.nav.map(item => {
          return (
            <li key={shortid.generate()}>
              {item.text === `Buy Tickets` ? (
                <BuyTickets className="db animate hover:dark-pink" />
              ) : item.text === `Our Story` ? (
                // Offset the "Our Story" link target because the section has no top padding
                <ScrollTo
                  href={item.link}
                  offset={128}
                  className="ph3 animate hover:dark-pink"
                >
                  {item.text}
                </ScrollTo>
              ) : (
                <ScrollTo href={item.link} className="ph3 animate hover:dark-pink">
                  {item.text}
                </ScrollTo>
              )}
            </li>
          )
        })}
      </ul>
    </nav>
  </div>
)



// WEBPACK FOOTER //
// ./src/sections/Header.js